import React, {ReactElement, useEffect} from 'react';
import Header from '../../components/page/header/header';
import Catalog from '../../components/catalog/catalog';
import Footer from '../../components/page/footer/footer';
import Promo from '../../components/promo/promo';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import GoodsPopup from '../../components/goods/goods-popup/goods-popup';
import ModalContainer from '../../components/page/modal-container/modal-container';
import {Helmet} from 'react-helmet-async';
import {CanonicalUrl, PageDesc, PageTitle} from '../../const/seo';
import {showModal} from '../../store/actions';
import {ModalType} from '../../types/modalType';
import {useAppDispatch} from '../../hooks';
import {AppRoute} from '../../const/common';
import TopCategory from '../../components/main-page/top-category/top-category';
import HitGoods from '../../components/main-page/hit-goods/hit-goods';
import NewGoods from '../../components/main-page/new-goods/new-goods';

export default function MainScreen(): ReactElement {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const hash = location.hash;

  console.log(params)

  useEffect(() => {
    switch (hash) {
      case '#registration':
        navigate(AppRoute.Root);
        dispatch(showModal(ModalType.Registration));

        break;
    }
  }, [hash]);

  return (
    <>
      <Helmet>
        {!params.id && <title>{PageTitle.Main}</title>}
        {params.id
          ? <link rel="canonical" href={`${CanonicalUrl.Main}products/${params.id}`}/>
          : <link rel="canonical" href={CanonicalUrl.Main}/>
        }
        <meta name="description" content={PageDesc.Main}></meta>
      </Helmet>
      <Header />
      <Promo />
      {/*<Catalog />*/}
      <TopCategory/>
      <HitGoods/>
      <NewGoods/>
      {/*{params.id && <GoodsPopup />}*/}
      <Footer />
      <ModalContainer />
    </>
  );
}
